import React from 'react';
import PropTypes from 'prop-types'
import NRTRadioButton from "./RadioButton"

class NRTRadioGroup extends React.Component {

    state = {
        checkedOption :  ''
    }

    static getDerivedStateFromProps(nextProps) {
        return {
            checkedOption  : nextProps.value + ''
        }
    }


    setChecked = (option) => {

        if (this.props.disabled)
            return

        const { checkedOption } = this.state

        if (checkedOption !== option.value) {
            this.setState({ checkedOption : option.value })
            this.props.onChange(option.value)
        }
    }


    render() {

        const { checkedOption } = this.state

        return (
            <div style={this.props.style || {}}>
                {
                    this.props.options.map((option) =>
                        <NRTRadioButton
                            key={`${this.props.name}-option-${option.value}`}
                            option={option}
                            checked={checkedOption + '' === option.value + ''}
                            onClick={(opt) => this.setChecked(opt)}
                            />
                    )
                }
            </div>
        )
    }
}


NRTRadioGroup.propTypes = {

    options: PropTypes.arrayOf(PropTypes.object),
    style: PropTypes.object,
}

export default NRTRadioGroup



// WEBPACK FOOTER //
// ./src/components/_common/_form/FormInput/RadioGroup/index.js